import ModalAlerta from "global/component/Genericos/ModalAlerta/ModalAlerta";
import ToasterV2 from "global/component/Genericos/Toaster/ToasterV2";
import { hideModal, showModal } from "global/context/action/modal/modal";
import { showToaster } from "global/context/action/toaster/toaster";
import { GlobalContext } from "global/context/Provider";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { resetOrdenEstudio } from "_+_Portal/context/Actions/ordenEstudio/ordenEstudio";
import { PortalContext } from "_+_Portal/context/Provider";
import CardBlueHeart from "_+_Portal/_-_Autocheckin/components/genericos/CardBlueHeart/CardBlueHeart";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import MotivoRechazo from "_+_Portal/_-_Autocheckin/components/genericos/MotivoRechazo/MotivoRechazo";
import PasoBar from "_+_Portal/_-_Autocheckin/components/genericos/PasoBar/PasoBar";
import CountdownTimer from "_+_Portal/_-_Autocheckin/components/genericos/CountdownTimer/CountdownTimer";
import {
  setOrden,
  wsGetEstadoOrden,
  wsUpdateUsuarioAltaOrden
} from "_+_Portal/_-_Autocheckin/context/action/orden";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { setRuta } from "_+_Portal/_-_Autocheckin/context/action/ruta";
import { wsGetTurnoById } from "_+_Portal/_-_Autocheckin/context/action/turnosAutoCheckIn";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import { proximoPaso } from "../PagesFun";
import { IonSpinner } from "@ionic/react";
import { ContainerSubirOrden, Paso2Body } from "./localStyle";
import { setIdTipoPuntoControl } from "_+_Portal/_-_Autocheckin/context/action/puntoControl";
import SubirOrdenComponent from "_+_Portal/_-_Autocheckin/components/genericos/SubirOrdenComponent/SubirOrdenComponent";

const SubirOrden = ({ turnoActual, setLoading }) => {
  const { modalDispatch, toasterDispatch, toasterState, modalAlertaState } =
    useContext(GlobalContext);
  const {
    ordenEstudioState,
    selectDropDownState,
    ordenLaboratorioState,
    ordenEstudioDispatch,
  } = useContext(PortalContext);

  const {
    turnosSeleccionadosState,
    ordenDispatch,
    rutaState,
    pasoDispatch,
    rutaDispatch,
    turnosAutoCheckInDispatch,
    puntoControlDispatch,
    usuarioAltaOrdenDispatch
  } = useContext(AutocheckContext);

  const [flgPendiente, setFlgPendiente] = useState(false);
  const [loop, setLoop] = useState(false);
  const [tiempoEspera, setTiempoEspera] = useState("");
  const [txtTiempoEspera, setTxtTiempoEspera] = useState("");
  const interval = useRef();
  const isComponentMounted = useRef(true);
  const isFirstResponse = useRef(true);

  const listTurnosSeleccionado =
    turnosSeleccionadosState?.turnosSeleccionados?.data ?? [];

  const turno = listTurnosSeleccionado?.[turnoActual];

  const txtPendiente = "Tiempo estimado de espera:";
  const txtSiguienteEnCola = "Siguiente en la cola";

  //----------------------Funciones----------------------------
  const dismiss = (limpiarOrden) => {
    hideModal()(modalDispatch);
    if (limpiarOrden) {
      setOrden([])(ordenDispatch);
    }
  };

  const nextStepEstadoOrden = (data, isCorrect) => {
    if (isCorrect) {
      if (data.tiempoEspera !== undefined && data.tiempoEspera !== null && data.tiempoEspera !== "") {
        if (isFirstResponse.current) {
          setTiempoEspera(data.tiempoEspera);
          setTxtTiempoEspera(txtPendiente);
          isFirstResponse.current = false;
        } else if (data.tiempoEspera !== tiempoEspera) {
          setTiempoEspera(data.tiempoEspera);
          setTxtTiempoEspera(txtPendiente);
        } else {
          setTxtTiempoEspera(txtSiguienteEnCola);
        }
      }

      if (data.estadoOrden === "Validado") {
        setFlgPendiente(false);
        siguientePaso();
      } else if (data.estadoOrden === "Rechazado") {
        setFlgPendiente(false);
        showModal(
          <MotivoRechazo
            idturno={turno?.idturno}
            motivoRechazo={data.motivoRechazo}
            motivoRechazoObservacion={data.motivoRechazoObservacion}
            motivoRechazoRecepcion={data.motivoRechazoRecepcion}
          />,
          "Orden Rechazada",
          dismiss,
          false,
          {},
          "centro",
          true,
        )(modalDispatch);
        // No programar siguiente llamada - loop terminado
      } else {
        // Estado aún "Pendiente" - programar siguiente llamada después de 3 segundos
        scheduleNextCall();
      }
    } else {
      setFlgPendiente(false);
      // Error - no programar más llamadas
    }
  };

  // Programa la siguiente llamada al endpoint después de un delay
  const scheduleNextCall = useCallback(() => {
    if (!isComponentMounted.current) return;

    interval.current = setTimeout(() => {
      if (isComponentMounted.current) {
        wsGetEstadoOrden(
          turno?.idturno,
          true,
          nextStepEstadoOrden,
        )(ordenDispatch);
      }
    }, 3000);
  }, [turno?.idturno, ordenDispatch]);

  // Inicia el loop - primera llamada inmediata
  const loopSubirOrden = () => {
    setFlgPendiente(true);
    hideModal()(modalDispatch);
    // Primera llamada inmediata
    wsGetEstadoOrden(
      turno?.idturno,
      true,
      nextStepEstadoOrden,
    )(ordenDispatch);
  };

  const stopLoopSubirOrden = useCallback(() => {
    if (interval.current) {
      clearTimeout(interval.current);
      interval.current = null;
    }
  }, []);

  const handleClickVolver = () => {
    stopLoopSubirOrden();
    setPaso("TurnosDelDia")(pasoDispatch);
  };

  const siguientePaso = () => {
    const ruta = rutaState?.ruta?.data;
    const idPacFamiliar = selectDropDownState?.selectDropDown?.selectGlobal
      ?.pacienteElegido?.paciente?.codigo
      ? selectDropDownState?.selectDropDown?.selectGlobal?.pacienteElegido
        ?.paciente?.codigo
      : false;
    let nextStepTurnoById = (isCorrect, data) => {
      let pathUpdated = [];
      if (isCorrect) {
        if (
          data?.resumen?.validaOnline ||
          data?.resumen?.validaOnlineEstado === "Pendiente"
        ) {
          pathUpdated.push("ValidarCobertura");
        }
        if (data?.resumen?.monto) {
          pathUpdated.push("AbonarMP");
        }
        if (ruta?.length) pathUpdated.push(ruta.pop());
        setRuta(proximoPaso(pathUpdated, setPaso, pasoDispatch))(rutaDispatch);
      }
    };

    setLoading("Actualizando información de turno...");
    wsGetTurnoById(
      turno?.idturno,
      nextStepTurnoById,
      idPacFamiliar,
    )(turnosAutoCheckInDispatch);
  };

  const enviarPuntoControl = () => {
    setLoading(true);
    const idTipoPuntoControl = 5;
    setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
    setPaso("PuntoControl")(pasoDispatch);
  };

  // Formateador de texto dinámico para el countdown
  const formatter = (secs) => {
    if (secs > 60) return "Queda más de un minuto";
    if (secs > 30) return "Menos de un minuto";
    return "Casi listo...";
  };

  // Callback cuando el timer llega a 0
  const handleTimerEnd = () => {
    // Mantener el último tiempo de espera
    setTiempoEspera(tiempoEspera);
  };

  //----------------------Funciones----------------------------

  //----------------------useEffects----------------------------

  useEffect(() => {
    if (
      ordenEstudioState?.ordenEstudio?.eliminado === "" ||
      ordenLaboratorioState?.ordenLaboratorio?.eliminado === ""
    ) {
      hideModal()(modalDispatch);
      showToaster(
        {
          texto: "Orden eliminada exitosamente",
          tipo: "success",
        },
        "centroArriba",
      )(toasterDispatch);
      resetOrdenEstudio()(ordenEstudioDispatch);
    }
    //eslint-disable-next-line
  }, [
    ordenEstudioState?.ordenEstudio?.eliminado,
    ordenLaboratorioState?.ordenLaboratorio?.eliminado,
  ]);

  useEffect(() => {
    let idInterval;
    if (!loop && turno?.tieneFotoOrden) {
      wsUpdateUsuarioAltaOrden(turno.idturno, true)(usuarioAltaOrdenDispatch);
      idInterval = loopSubirOrden();
      setLoop(true);
    }
    return () => {
      clearInterval(idInterval);
    };
  }, []);

  // Cleanup al desmontar
  useEffect(() => {
    return () => {
      isComponentMounted.current = false;
      stopLoopSubirOrden();
    };
  }, [stopLoopSubirOrden]);

  //----------------------useEffects----------------------------

  if (!turno) return null;

  return (
    <LayoutPasos
      volverTo={"/autocheckin/resumen"}
      handleClick={handleClickVolver}
      type={"no-circle"}
      title={"orden médica"}
      children={
        <>
          {toasterState?.toaster?.show && <ToasterV2 />}
          {modalAlertaState?.modalAlerta?.show && <ModalAlerta />}
          <CardBlueHeart
            medico={turno?.medico ? turno?.medico : turno?.especialidad}
            turnoTitle={turno?.especialidad}
            pasoActual={turnoActual + 1}
            pasoTotal={listTurnosSeleccionado?.length ?? 0}
          />
          <ContainerSubirOrden>
            <PasoBar paso={"SubirOrden"} />
          </ContainerSubirOrden>
          <Paso2Body>
            {!flgPendiente ? (
              <SubirOrdenComponent
                turno={turno}
                callback={loopSubirOrden}
                enviarPuntoControl={enviarPuntoControl}
              />
            ) : (
              <div className="container-texto-promocional">
                {txtTiempoEspera !== "" && tiempoEspera !== "" ? (
                  <CountdownTimer
                    text={txtTiempoEspera}
                    timeString={tiempoEspera}
                    onComplete={handleTimerEnd}
                    textFormatter={formatter}
                  />
                ) : (
                  <>
                    <span className="rb18m">Aguarde mientras controlamos la orden subida</span>
                    <IonSpinner name="lines" />
                  </>
                )}
              </div>
            )}
          </Paso2Body>
        </>
      }
    ></LayoutPasos>
  );
};

export default SubirOrden;
